import { render, staticRenderFns } from "./monitoring-campaign.vue?vue&type=template&id=916ff85a&scoped=true&"
import script from "./monitoring-campaign.vue?vue&type=script&lang=js&"
export * from "./monitoring-campaign.vue?vue&type=script&lang=js&"
import style0 from "./monitoring-campaign.vue?vue&type=style&index=0&id=916ff85a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "916ff85a",
  null
  
)

export default component.exports